<template>
  <div class="noticeSend">
    <OACard>
      <formComponent :form-data="formData" ref="formComponent"></formComponent>
    </OACard>
    <OACard class="text-right">
      <OAButton :disabled="disabled" @click="handleValidate('handleSend')"
        >发送通知</OAButton
      >
      <OAButton @click="handleValidate('handlePreview')">预览</OAButton>
      <OAButton :disabled="disabled" @click="handleValidate('handleDraft')"
        >存草稿</OAButton
      >
      <OAButton @click="handleCancel">取消</OAButton>
    </OACard>
    <noticeDetail
      v-if="visible"
      :visible.sync="visible"
      :props="detailValue"
      :isEdit="false"
    ></noticeDetail>
  </div>
</template>
<script>
import OACard from "@/components/OACard/OACard";
import noticeDetail from "./noticeDetail.vue";
import formComponent from "@/components/formComponents/form-component";
import skyRichText from "@/components/formComponents/sky-rich-text";
import notice from "@/services/notice.js";
import { confirm } from "@/common/messageBox";
import {
  // getUrlQuery,
  getValue,
  // resFilter,
  setValue
  // clearValue
} from "@/common/util.js";
export default {
  name: "noticeSend",
  components: {
    OACard,
    noticeDetail,
    formComponent,
    skyRichText
  },
  data() {
    return {
      formData: {
        receiverInfo: {
          label: "发送给：",
          formType: "a-organizationCascader",
          props: {
            label: "name",
            value: "id",
            multiple: true,
            checkStrictly: false
          },
          col: 10,
          offset: 4,
          value: [],
          filterable: true,
          placeholder: "请选择接收人",
          rules: [
            {
              required: true,
              message: "请输入接收人",
              trigger: "change"
            }
          ]
        },
        title: {
          label: "通知主题：",
          formType: "a-input",
          col: 10,
          offset: 4,
          value: undefined,
          placeholder: "请输入通知主题",
          clearable: true,
          rules: [
            {
              required: true,
              message: "请输入通知主题",
              trigger: "change"
            }
          ]
        },
        sender: {
          label: "发送人：",
          formType: "a-input",
          col: 10,
          offset: 4,
          value: undefined,
          placeholder: "请输入发送人",
          clearable: true,
          rules: [
            {
              required: true,
              message: "请输入发送人",
              trigger: "change"
            }
          ]
        },
        url: {
          label: "附件：",
          formType: "a-sky-upload",
          col: 24,
          offset: 4,
          platform: "oa-pri-oss",
          judgeType: "text",
          value: [],
          tip: "请上传.pdf格式文件"
        },
        content: {
          formType: "a-rich-text",
          value: undefined,
          height: "500px",
          class: "rich-text",
          width: "80%",
          contentStyle: "img {max-width:100%;height:auto;display:block;}"
        }
      },
      detailValue: {},
      visible: false,
      pageData: undefined,
      disabled: false
    };
  },
  async mounted() {
    if (this.$route.query.id) {
      let res = await notice.getDetailsById({ noticeId: this.$route.query.id });
      if (res.data.data.sendStatus == "已发送") {
        this.disabled = true;
        this.$message.warning("当前通知已发送，请刷新列表。页面将在两秒后关闭");
        setTimeout(function () {
          window.close();
        }, 2000);
      }
      this.pageData = res.data.data;
      setValue(this.pageData, this.formData);
    }
  },
  methods: {
    handleContent(content) {
      return content.replace(
        /<img/g,
        "<img style='max-width:100%;height:auto;display:block;'"
      );
    },
    getParam() {
      return this.$route.query.id
        ? { id: this.pageData.id, ...getValue({ ...this.formData }) }
        : getValue({ ...this.formData });
    },
    handleValidate(val) {
      this.$refs.formComponent.validate((valid) => {
        if (valid) {
          this[val]();
        }
      });
    },
    handlePreview() {
      this.detailValue = this.getParam();
      this.visible = true;
    },
    async handleSend() {
      let res = await confirm("是否确认发送该通知？", "提示");
      if (res) {
        let param = this.getParam();
        param.content = this.handleContent(param.content);
        await notice.sendNotice(param);
        this.$message.success("发送成功");
        this.disabled = true;
        setTimeout(() => {
          window.close();
        }, 1000);
      }
    },
    async handleDraft() {
      let param = this.getParam();
      param.content = this.handleContent(param.content);
      await notice.saveNotice(param);
      this.$message.success("保存草稿成功");
      this.disabled = true;
      setTimeout(() => {
        window.close();
      }, 1000);
    },
    async handleCancel() {
      let res = await confirm(
        "此操作将退出该编辑页，内容将不会保存，是否继续？",
        "提示"
      );
      if (res) {
        setTimeout(() => {
          window.close();
        }, 1000);
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/notice/noticeSend.vue